import * as f01 from '../actions/f01.actions';
import { convertCurrency } from '../utils';
export interface State {
  f01: any;
}
export const initialState = {
    'policy_information': [
        {
            'F01_03': '13888888',
            'F01_04': 'Wealth Amplifier Investment Plan',
            'F01_05': '30,000.00',
            'F01_06': 'Single',
            'F01_07': 'HKD',
            'F01_08': '32,974.08',
            'content': {
                'content_details': [
                    {
                        'F01_12': 'Aberdeen Standard SICAV I - North American Equity Fund - A Acc USD',
                        'F01_13': '03/01/2020',
                        'F01_14': 'USD',
                        'F01_15': '167.26200',
                        'F01_16': '25.274',
                        'F01_17': '4,227.45',
                        'F01_18': '32,974.08',
                        'allocation': '100%'
                    }
                ],
                'content_summary': {
                    'currency': 'HKD',
                    'total_amount': '32,974.08'
                }
            }
        }
    ]
};
//  Takes an amount and returns the percentage in "INT_VALUE%" format.
function convertPercentage(amount, sum) {
    return Math.round(amount * 100.0 / sum) + '%';
}
/* // Takes a currency string and format it into "##,###.##" format.
function convertCurrency(curr) {
    return curr.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',').toString();
} */
export function reducer(state = initialState, action: f01.Actions) {
  switch (action.type) {
    case f01.GO_TO_PAGE_F01: {
      const payload = action.payload;
      const result = [];
      payload[0].policy.forEach(e => {
          if (e.policyInfoView.isMyWealthFlag === 'Y') {
              const allocation = {
                  'content_details': [],
                  'content_summary': {
                      'currency': e.policyPaymentInfoView.policyCurrency,
                      'total_amount': '0.00'
                  }
              };
              result.push({
                    'F01_03': e.policyInfoView.policyNo + e.policyInfoView.policySymbol,
                    'F01_03A': e.policyInfoView.policyNo,
                    'F01_04': e.policyInfoView.productName,
                    'F01_05': convertCurrency(e.policyInfoView.premPlannedAmount, 2),
                    'F01_06': e.policyInfoView.policyPaymentMode,
                    'F01_07': e.policyInfoView.policyCurrency,
                    'F01_08': convertCurrency(e.policyInfoView.policyValueInPolicyCurrency, 2) + e.policyInfoView.policyValueSymbol,
                    'content': allocation
              });
          }
      });
      return Object.assign({}, state, {'policy_information': result});
    }

    case f01.SET_SELECTED_POLICY_NO: {
        const policy_no = action.payload;
        return Object.assign({}, state, {
            ...state,
            selected_policy_no: policy_no
        });
    }

    default:
      return state;
  }
}
